const FETCH_FEEDBACK_DATA_SUCCESS = 'FETCH_FEEDBACK_DATA_SUCCESS';
const SET_FEEDBACK_DATA_SUCCESS = 'SET_FEEDBACK_DATA_SUCCESS';
const SET_FEEDBACK_DETAILS = 'SET_FEEDBACK_DETAILS';

const feedbackDataReducer = (state = {
  data : null,
  feedbackSubmitted: false,
  submitClicked: false,
  feedbackType: null,
  eventType: null,
  locale:null,
  deliveryMode:null
}, action) => {
    switch (action.type) {
      case FETCH_FEEDBACK_DATA_SUCCESS:{
        return{
        ...state,
        data: action.payload}
      }
    
    case SET_FEEDBACK_DATA_SUCCESS : {
      return{
        ...state,
        feedbackSubmitted: true
      }
    }

    case SET_FEEDBACK_DETAILS : {
      return {
        ...state,
        feedbackType : action.payload.feedbackType,
        eventType : action.payload.eventType,
        locale : action.payload.locale,
        deliveryMode: action.payload.deliveryMode        
      }
    }
    default : {
      break;
    }
  }
    return state;
  }

  
  export default feedbackDataReducer;
  